import { render, staticRenderFns } from "./VolunteerserviceDetail.vue?vue&type=template&id=a624e3ce&scoped=true"
import script from "./VolunteerserviceDetail.vue?vue&type=script&lang=js"
export * from "./VolunteerserviceDetail.vue?vue&type=script&lang=js"
import style0 from "./VolunteerserviceDetail.vue?vue&type=style&index=0&id=a624e3ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a624e3ce",
  null
  
)

export default component.exports